var _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var SvgQuotes = function SvgQuotes(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 30,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#1E1E1E",
    d: "M0 0h41v30H0z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#quotes_svg__clip0_1762_6329)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M-455-6396h1600V8030H-455z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#E0E0E0",
    d: "M-356.5-55.5h1403v423h-1403z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.344 14.224c6.384-.112 10.864 3.248 10.864 8.064 0 4.592-3.36 7.28-7.728 7.28-5.824 0-9.968-4.704-9.968-10.976 0-9.856 7.28-16.688 18.48-18.592v5.152c-7.504 1.568-10.64 5.152-11.648 9.072zm-22.512 0c6.384-.112 10.864 3.248 10.864 8.064 0 4.592-3.36 7.28-7.728 7.28C4.144 29.568 0 24.864 0 18.592 0 8.736 7.28 1.904 18.368 0v5.152C10.976 6.72 7.84 10.304 6.832 14.224z",
    fill: "#F05"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "quotes_svg__clip0_1762_6329"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(-455 -6396)",
    d: "M0 0h1600v14426H0z"
  })))));
};
export default SvgQuotes;